<div class="payment-form-content form-root" [class]="rootCssClasses()" [style]="rootCssVars()">
    <form class="sp-lpc-form" style="pointer-events: none">
        <div class="sp-ui-text payment-form-description">
            <h2 class="payment-modal-title">
                {{ widgetData().paymentFormName }}
            </h2>
            @if (isProductTypeDefault()) {
                <p class="payment-modal-product-name">
                    {{ widgetData().productName }}
                </p>
                @if (!paymentElement()?.isEditableTotalCost) {
                    <p class="payment-modal-product-price">
                        {{ paymentElement()?.amount }} {{ paymentElement()?.currency }}
                    </p>
                }
            }
        </div>

        @if (paymentElement()?.isEditableTotalCost) {
            <div class="min-amount-control form-field">
                <label>{{ "amount" | translate }}</label>
                <div class="input-group">
                    <input class="form-control" [class]="fieldCssClasses()" />
                    <div class="input-group-addon">
                        {{ paymentElement().currency }}
                    </div>
                </div>
                <div class="sp-ui-text">
                    <p>
                        <small>{{
                            "minimal_amount"
                                | translate: { PRICE: paymentElement().amount, CURRENCY: paymentElement().currency }
                        }}</small>
                    </p>
                </div>
            </div>
        }

        @if (isProductTypeDefault()) {
            <span class="modal-divider"></span>
        }

        <div>
            @for (control of elements(); track control; let index = $index) {
                <div class="field-block form-field">
                    @switch (true) {
                        @case (typeGuards.isInput(control)) {
                            @if (inputSettings().showLabels) {
                                <label [class.hidden]="control.type === formInputType.hidden">
                                    {{ control.label }}{{ control.required ? " *" : "" }}
                                </label>
                            }
                            @if (control.type === formInputType.phone && control.isDynamicPlaceholderEnabled) {
                                <ngx-intl-tel-input
                                    [cssClass]="'form-control ' + fieldCssClasses()"
                                    [enableAutoCountrySelect]="true"
                                    [selectFirstCountry]="false"
                                    [separateDialCode]="true"
                                    [enablePlaceholder]="true"
                                    [searchCountryFlag]="true"
                                    [phoneValidation]="true"
                                    [searchCountryField]="[SearchCountryField.All]"
                                    [excludeCountries]="excludeCountries"
                                    [selectedCountryISO]="CountryISO()"
                                    [numberFormat]="PhoneNumberFormat.International"
                                />
                            } @else {
                                <input
                                    class="form-control"
                                    [class]="fieldCssClasses()"
                                    [type]="control.htmlInputType"
                                    [placeholder]="control.placeholder | translate"
                                />
                            }
                        }
                        @case (typeGuards.isTextarea(control)) {
                            @if (inputSettings().showLabels) {
                                <label> {{ control.label }}{{ control.required ? " *" : "" }} </label>
                            }
                            <textarea
                                class="form-control-textarea"
                                [class]="fieldCssClasses()"
                                [attr.placeholder]="control.placeholder"
                            ></textarea>
                        }
                        @case (typeGuards.isCheckbox(control)) {
                            <label class="sp-checkbox">
                                <input [type]="control.htmlInputType" />
                                @if (control.required) {
                                    <span
                                        class="checkbox-text"
                                        [innerHTML]="' ' + (control.label | removePTags) + ' *'"
                                    ></span>
                                }
                                @if (!control.required) {
                                    <span
                                        class="checkbox-text"
                                        [innerHTML]="' ' + (control.label | removePTags)"
                                    ></span>
                                }
                            </label>
                        }
                        @case (typeGuards.isRadio(control)) {
                            @if (inputSettings().showLabels) {
                                <label> {{ control.label }}{{ control.required ? " *" : "" }} </label>
                            }
                            @for (option of control.options; track option) {
                                <div class="radio-options">
                                    <label class="sp-radio">
                                        <input [type]="control.htmlInputType" [checked]="option.selected" />
                                        <span> {{ option.label }}</span>
                                    </label>
                                </div>
                            }
                        }
                        @case (typeGuards.isSelect(control)) {
                            @if (inputSettings().showLabels) {
                                <label>
                                    @if (inputSettings().showLabels) {
                                        <label> {{ control.label }}{{ control.required ? " *" : "" }} </label>
                                    }
                                </label>
                            }
                            <ng-select
                                [placeholder]="getPlaceholder(control.options) | translate"
                                [items]="control.options"
                                [multiple]="$any(control.htmlInputType) === 'multiselect'"
                            >
                            </ng-select>
                        }
                    }
                </div>
            }
        </div>

        @if (widgetData().paymentElements.length > 1) {
            <div class="form-field">
                @if (inputSettings().showLabels) {
                    <label>{{ "payment_method" | translate }}</label>
                }
                <button class="form-dropdown-button">
                    <div>
                        <img
                            [src]="getPaymentIconSrc(widgetData().paymentElements[0].type)"
                            [alt]="widgetData().paymentElements[0].type"
                        />
                        <span>{{ getPaymentElementLabel(paymentElement().type, 0) | translate }}</span>
                    </div>
                    <span class="caret"></span>
                </button>
            </div>
        }

        @if (
            widgetData().paymentElements.length > 1 && productSettings()?.courseId && !productSettings()?.courseTariffId
        ) {
            <div class="form-field">
                @if (inputSettings().showLabels) {
                    <label>{{ "payment_method" | translate }}</label>
                }
                <button class="form-dropdown-button">
                    <div>
                        <img [src]="getPaymentIconSrc(paymentElement().type)" [alt]="paymentElement().type" />
                        <span>{{ paymentsList[paymentElement().type]?.label | translate }}</span>
                    </div>
                    <span class="caret"></span>
                </button>
            </div>
        }
        @if (!isProductTypeEduCourse()) {
            @if (isPromoCodeEnabled()) {
                <div class="field-block form-field">
                    @if (inputSettings().showLabels) {
                        <label>{{ promoCodeLabel() | translate }}</label>
                    }
                    <input
                        type="text"
                        class="form-control"
                        [class]="fieldCssClasses()"
                        [placeholder]="promoCodePlaceholder() | translate"
                    />
                </div>
            }
        }
        @if (isProductTypeEduCourse()) {
            <span class="modal-divider"></span>
            <div class="sp-ui-text payment-form-description">
                <p class="payment-modal-product-name">
                    {{ widgetData().productName }}
                </p>
                @if (!paymentElement()?.isEditableTotalCost) {
                    <p class="payment-modal-product-price">
                        {{ paymentElement()?.amount }} {{ paymentElement()?.currency }}
                    </p>
                }
            </div>
        }

        <div class="form-button-wrapper form-vertical" [style]="buttonCssVars()">
            <a class="submit-btn" [class]="getButtonStyles(formButtonSettings())">
                @if (formButtonSettings().buttonIcon?.isActive) {
                    <span class="icon" [innerHTML]="getIcon(formButtonSettings().buttonIcon?.icon)"></span>
                }
                {{ formButtonSettings().label }}
            </a>
        </div>

        @if (!!widgetData().modalTextHint) {
            <div class="modal-hint-text" [innerHtml]="widgetData().modalTextHint | spSafeHtml"></div>
        }
    </form>
</div>
